import { defaultMutationFn } from 'api/useAPI';
import { Authentication, Location } from 'models';
import { useMutation, useQuery } from 'react-query';

export function useToken() {
  const path = '/authenticate/token';
  return useQuery<Authentication>(path);
}

export function useChangeLocation() {
  return useMutation(async ({ locationId }: { locationId: string }) =>
    defaultMutationFn(`/authenticate/locations/${locationId}`, 'POST')
  );
}

export function useLocations() {
  const path = '/authenticate/locations';
  return useQuery<Location[]>(path);
}

export function useCurrentLocation() {
  const { data } = useToken();
  return data?.location;
}
